import { render } from "./multi-static.vue?vue&type=template&id=45ef9825&lang=pug"
import script from "./multi-static.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-static.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__